export function getServerDebugInfoString(response) {
    var _a, _b;
    if (!response || !response.headers) {
        return '';
    }
    var headers = response.headers;
    var backendServer = headers['X-CalculatedBETarget'] || '';
    var frontendServer = headers['X-FEServer'] || '';
    var extendedInfoString = '';
    var extendedInfo = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.diagnostics_data) === null || _b === void 0 ? void 0 : _b.extended_info;
    if (extendedInfo) {
        extendedInfoString = "WorkingSetFilesPlugin:".concat(extendedInfo.WorkingSetFilesPlugin, ", MruFilesPlugin:").concat(extendedInfo.MruFilesPlugin, ", Version:").concat(extendedInfo.Version);
    }
    return "BE:".concat(backendServer, ", FE:").concat(frontendServer, "|").concat(extendedInfoString);
}
//# sourceMappingURL=getServerDebugInfoString.js.map